// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__6FhjK","Success":"Button_Success__1Vorv","Danger":"Button_Danger__3p5qJ"};